import { Link } from "react-router-dom";

/**
 * Persistent brand mark — fixed bottom-right on every page.
 * Gold ring matches the existing accent system.
 */
export const FloatingMark = () => {
  return (
    <Link
      to="/"
      aria-label="DrSullySpeaks — Home"
      className="hidden md:block fixed bottom-5 right-5 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-gold/30 blur-md opacity-60 group-hover:opacity-100 transition-opacity" />
      <span className="relative block h-12 w-12 md:h-14 md:w-14 rounded-full overflow-hidden ring-2 ring-gold/70 group-hover:ring-gold shadow-[0_8px_24px_-6px_hsl(var(--gold)/0.5)] transition-all bg-navy-deep">
        {/* Rendered at 48–56 CSS px. The 64px favicon is the right weight on
            1x screens but goes soft at 2x/3x, so hand the browser a DPR
            srcset and let it pick the smallest crisp candidate per device. */}
        <img
          src="/favicon.png"
          srcSet="/favicon.png 64w, /apple-touch-icon.png 180w"
          sizes="56px"
          width={56}
          height={56}
          alt=""
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover"
        />
      </span>
    </Link>
  );
};
